import { render, staticRenderFns } from "./topic-item.vue?vue&type=template&id=6b13264e&scoped=true&"
import script from "./topic-item.vue?vue&type=script&lang=js&"
export * from "./topic-item.vue?vue&type=script&lang=js&"
import style0 from "./topic-item.vue?vue&type=style&index=0&id=6b13264e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13264e",
  null
  
)

export default component.exports